// extracted by mini-css-extract-plugin
export default {"title-list__list":"title-list__list__XzDWc","in-columns":"in-columns__4nw-9","title-list__item":"title-list__item__BTY5l"};